"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _marked = [evalExpression, evalCallExpression, evalUnaryExpression, evalBinaryExpression, evalLogicalExpression, evalConditionalExpression, evalStatement, evalVariableDeclaration, evalFunctionDeclaration, evalIfStatement, evalExpressionStatement, evalReturnStatement, evalBlockStatement, evalProgram].map(regeneratorRuntime.mark);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var errorTypes_1 = require("./errorTypes");
var astUtils_1 = require("./astUtils");
var Closure_1 = require("./Closure");
var initialState = {
    isRunning: false,
    frames: immutable_1.Stack(),
    scopes: immutable_1.Map(),
    errors: immutable_1.List(),
    node: undefined,
    value: undefined,
    _isReturned: false,
    _done: false
};
var frameCtr = 0;
var lambdaCtr = 0;

var InterpreterState = function (_immutable_1$Record) {
    _inherits(InterpreterState, _immutable_1$Record);

    function InterpreterState() {
        _classCallCheck(this, InterpreterState);

        return _possibleConstructorReturn(this, (InterpreterState.__proto__ || Object.getPrototypeOf(InterpreterState)).apply(this, arguments));
    }

    _createClass(InterpreterState, [{
        key: "with",
        value: function _with(params) {
            return this.merge(params);
        }
    }]);

    return InterpreterState;
}(immutable_1.Record(initialState));

exports.InterpreterState = InterpreterState;
exports.createState = function () {
    var globalEnv = {
        name: '_global_',
        parent: undefined,
        environment: immutable_1.Map()
    };
    return new InterpreterState({
        _done: false,
        _isReturned: false,
        _result: undefined,
        isRunning: false,
        frames: immutable_1.Stack.of(0),
        scopes: immutable_1.Map.of(0, globalEnv),
        errors: immutable_1.List(),
        value: undefined,
        node: undefined
    });
};
var stop = function stop(state) {
    return state.with({ isRunning: false });
};
var start = function start(state) {
    return state.with({ isRunning: true });
};
var defineVariable = function defineVariable(state, name, value) {
    var currentFrame = state.frames.peek();
    var scope = state.scopes.get(currentFrame);
    return state.with({
        scopes: state.scopes.set(currentFrame, Object.assign({}, scope, { environment: scope.environment.set(name, value) }))
    });
};
var popFrame = function popFrame(state) {
    return state.with({ frames: state.frames.pop() });
};
var pushFrame = function pushFrame(state, scope) {
    frameCtr++;
    return state.with({
        scopes: state.scopes.set(frameCtr, scope),
        frames: state.frames.push(frameCtr)
    });
};
var fatalError = function fatalError(state, error) {
    return state.with({
        errors: state.errors.push(error),
        isRunning: false
    });
};
var getEnv = function getEnv(name, state) {
    var scope = state.scopes.get(state.frames.peek());
    do {
        if (scope.environment.has(name)) {
            return scope.environment.get(name);
        } else {
            scope = state.scopes.get(scope.parent);
        }
    } while (scope);
    return undefined;
};
function evalExpression(node, state) {
    var value, selfEvaluating, nextState;
    return regeneratorRuntime.wrap(function evalExpression$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return state.with({ node: node, _done: false });

                case 2:
                    value = void 0;
                    selfEvaluating = false;
                    _context.t0 = node.type;
                    _context.next = _context.t0 === 'CallExpression' ? 7 : _context.t0 === 'UnaryExpression' ? 10 : _context.t0 === 'BinaryExpression' ? 13 : _context.t0 === 'LogicalExpression' ? 16 : _context.t0 === 'ConditionalExpression' ? 19 : _context.t0 === 'FunctionExpression' ? 22 : _context.t0 === 'Identifier' ? 26 : _context.t0 === 'Literal' ? 29 : 32;
                    break;

                case 7:
                    return _context.delegateYield(evalCallExpression(node, state), "t1", 8);

                case 8:
                    state = _context.t1;
                    return _context.abrupt("break", 33);

                case 10:
                    return _context.delegateYield(evalUnaryExpression(node, state), "t2", 11);

                case 11:
                    state = _context.t2;
                    return _context.abrupt("break", 33);

                case 13:
                    return _context.delegateYield(evalBinaryExpression(node, state), "t3", 14);

                case 14:
                    state = _context.t3;
                    return _context.abrupt("break", 33);

                case 16:
                    return _context.delegateYield(evalLogicalExpression(node, state), "t4", 17);

                case 17:
                    state = _context.t4;
                    return _context.abrupt("break", 33);

                case 19:
                    return _context.delegateYield(evalConditionalExpression(node, state), "t5", 20);

                case 20:
                    state = _context.t5;
                    return _context.abrupt("break", 33);

                case 22:
                    value = new Closure_1.default(node, state.frames.first(), lambdaCtr);
                    lambdaCtr++;
                    selfEvaluating = true;
                    return _context.abrupt("break", 33);

                case 26:
                    value = getEnv(node.name, state);
                    selfEvaluating = true;
                    return _context.abrupt("break", 33);

                case 29:
                    value = node.value;
                    selfEvaluating = true;
                    return _context.abrupt("break", 33);

                case 32:
                    return _context.abrupt("break", 33);

                case 33:
                    if (!selfEvaluating) {
                        _context.next = 40;
                        break;
                    }

                    nextState = state.with({ _done: true, node: node, value: value });
                    _context.next = 37;
                    return nextState;

                case 37:
                    return _context.abrupt("return", nextState);

                case 40:
                    _context.next = 42;
                    return state.with({ _done: true, node: node });

                case 42:
                    return _context.abrupt("return", state);

                case 43:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked[0], this);
}
exports.evalExpression = evalExpression;
function evalCallExpression(node, state) {
    var callee, args, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, exp, error;

    return regeneratorRuntime.wrap(function evalCallExpression$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    return _context2.delegateYield(evalExpression(node.callee, state), "t0", 1);

                case 1:
                    state = _context2.t0;
                    callee = state.value;

                    if (!(callee instanceof Closure_1.default)) {
                        _context2.next = 42;
                        break;
                    }

                    args = [];
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context2.prev = 8;
                    _iterator = node.arguments[Symbol.iterator]();

                case 10:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context2.next = 18;
                        break;
                    }

                    exp = _step.value;
                    return _context2.delegateYield(evalExpression(exp, state), "t1", 13);

                case 13:
                    state = _context2.t1;

                    args.push(state.value);

                case 15:
                    _iteratorNormalCompletion = true;
                    _context2.next = 10;
                    break;

                case 18:
                    _context2.next = 24;
                    break;

                case 20:
                    _context2.prev = 20;
                    _context2.t2 = _context2["catch"](8);
                    _didIteratorError = true;
                    _iteratorError = _context2.t2;

                case 24:
                    _context2.prev = 24;
                    _context2.prev = 25;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }

                case 27:
                    _context2.prev = 27;

                    if (!_didIteratorError) {
                        _context2.next = 30;
                        break;
                    }

                    throw _iteratorError;

                case 30:
                    return _context2.finish(27);

                case 31:
                    return _context2.finish(24);

                case 32:
                    state = pushFrame(state, callee.createScope(args));
                    _context2.next = 35;
                    return state.with({ _done: false, node: callee.node.body });

                case 35:
                    return _context2.delegateYield(evalBlockStatement(callee.node.body, state), "t3", 36);

                case 36:
                    state = _context2.t3;
                    _context2.next = 39;
                    return state.with({ _done: true, node: callee.node.body });

                case 39:
                    return _context2.abrupt("return", popFrame(state).merge({ _done: true }));

                case 42:
                    error = {
                        type: errorTypes_1.ErrorType.CallingNonFunctionValues,
                        node: {
                            type: 'AssignmentExpression',
                            operator: '=',
                            loc: node.callee.loc,
                            left: node.callee,
                            right: astUtils_1.createNode(callee)
                        }
                    };
                    return _context2.abrupt("return", fatalError(state, error));

                case 44:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked[1], this, [[8, 20, 24, 32], [25,, 27, 31]]);
}
function evalUnaryExpression(node, state) {
    var value;
    return regeneratorRuntime.wrap(function evalUnaryExpression$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    value = void 0;
                    return _context3.delegateYield(evalExpression(node.argument, state), "t0", 2);

                case 2:
                    state = _context3.t0;

                    if (node.operator === '!') {
                        value = !state.value;
                    } else if (node.operator === '-') {
                        value = -state.value;
                    } else {
                        value = +state.value;
                    }
                    return _context3.abrupt("return", state.with({ _done: true, value: value }));

                case 5:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked[2], this);
}
function evalBinaryExpression(node, state) {
    var left, right, result;
    return regeneratorRuntime.wrap(function evalBinaryExpression$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    return _context4.delegateYield(evalExpression(node.left, state), "t0", 1);

                case 1:
                    state = _context4.t0;
                    left = state.value;
                    return _context4.delegateYield(evalExpression(node.right, state), "t1", 4);

                case 4:
                    state = _context4.t1;
                    right = state.value;
                    result = void 0;
                    _context4.t2 = node.operator;
                    _context4.next = _context4.t2 === '+' ? 10 : _context4.t2 === '-' ? 12 : _context4.t2 === '*' ? 14 : _context4.t2 === '/' ? 16 : _context4.t2 === '%' ? 18 : _context4.t2 === '===' ? 20 : _context4.t2 === '!==' ? 22 : _context4.t2 === '<=' ? 24 : _context4.t2 === '<' ? 26 : _context4.t2 === '>' ? 28 : _context4.t2 === '>=' ? 30 : 32;
                    break;

                case 10:
                    result = left + right;
                    return _context4.abrupt("break", 33);

                case 12:
                    result = left - right;
                    return _context4.abrupt("break", 33);

                case 14:
                    result = left * right;
                    return _context4.abrupt("break", 33);

                case 16:
                    result = left / right;
                    return _context4.abrupt("break", 33);

                case 18:
                    result = left % right;
                    return _context4.abrupt("break", 33);

                case 20:
                    result = left === right;
                    return _context4.abrupt("break", 33);

                case 22:
                    result = left !== right;
                    return _context4.abrupt("break", 33);

                case 24:
                    result = left <= right;
                    return _context4.abrupt("break", 33);

                case 26:
                    result = left < right;
                    return _context4.abrupt("break", 33);

                case 28:
                    result = left > right;
                    return _context4.abrupt("break", 33);

                case 30:
                    result = left >= right;
                    return _context4.abrupt("break", 33);

                case 32:
                    result = undefined;

                case 33:
                    return _context4.abrupt("return", state.with({ value: result }));

                case 34:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked[3], this);
}
function evalLogicalExpression(node, state) {
    var left;
    return regeneratorRuntime.wrap(function evalLogicalExpression$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    return _context5.delegateYield(evalExpression(node.left, state), "t0", 1);

                case 1:
                    state = _context5.t0;
                    left = state.value;

                    if (!(node.operator === '&&' && left)) {
                        _context5.next = 8;
                        break;
                    }

                    return _context5.delegateYield(evalExpression(node.right, state), "t1", 5);

                case 5:
                    state = _context5.t1;
                    _context5.next = 11;
                    break;

                case 8:
                    if (!(node.operator === '||' && !left)) {
                        _context5.next = 11;
                        break;
                    }

                    return _context5.delegateYield(evalExpression(node.right, state), "t2", 10);

                case 10:
                    state = _context5.t2;

                case 11:
                    return _context5.abrupt("return", state);

                case 12:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked[4], this);
}
function evalConditionalExpression(node, state) {
    return regeneratorRuntime.wrap(function evalConditionalExpression$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    return _context6.delegateYield(evalExpression(node.test, state), "t0", 1);

                case 1:
                    state = _context6.t0;

                    if (!state.value) {
                        _context6.next = 7;
                        break;
                    }

                    return _context6.delegateYield(evalExpression(node.consequent, state), "t1", 4);

                case 4:
                    return _context6.abrupt("return", _context6.t1);

                case 7:
                    return _context6.delegateYield(evalExpression(node.alternate, state), "t2", 8);

                case 8:
                    return _context6.abrupt("return", _context6.t2);

                case 9:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked[5], this);
}
function evalStatement(node, state) {
    return regeneratorRuntime.wrap(function evalStatement$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return state.with({ node: node, _done: false });

                case 2:
                    _context7.t0 = node.type;
                    _context7.next = _context7.t0 === 'VariableDeclaration' ? 5 : _context7.t0 === 'FunctionDeclaration' ? 8 : _context7.t0 === 'IfStatement' ? 11 : _context7.t0 === 'ExpressionStatement' ? 14 : _context7.t0 === 'ReturnStatement' ? 17 : 20;
                    break;

                case 5:
                    return _context7.delegateYield(evalVariableDeclaration(node, state), "t1", 6);

                case 6:
                    state = _context7.t1;
                    return _context7.abrupt("break", 21);

                case 8:
                    return _context7.delegateYield(evalFunctionDeclaration(node, state), "t2", 9);

                case 9:
                    state = _context7.t2;
                    return _context7.abrupt("break", 21);

                case 11:
                    return _context7.delegateYield(evalIfStatement(node, state), "t3", 12);

                case 12:
                    state = _context7.t3;
                    return _context7.abrupt("break", 21);

                case 14:
                    return _context7.delegateYield(evalExpressionStatement(node, state), "t4", 15);

                case 15:
                    state = _context7.t4;
                    return _context7.abrupt("break", 21);

                case 17:
                    return _context7.delegateYield(evalReturnStatement(node, state), "t5", 18);

                case 18:
                    state = _context7.t5;
                    return _context7.abrupt("break", 21);

                case 20:
                    return _context7.abrupt("break", 21);

                case 21:
                    return _context7.abrupt("return", state.with({ _done: true, node: node }));

                case 22:
                case "end":
                    return _context7.stop();
            }
        }
    }, _marked[6], this);
}
exports.evalStatement = evalStatement;
function evalVariableDeclaration(node, state) {
    var declarator, ident;
    return regeneratorRuntime.wrap(function evalVariableDeclaration$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    declarator = node.declarations[0];
                    ident = declarator.id;
                    return _context8.delegateYield(evalExpression(declarator.init, state), "t0", 3);

                case 3:
                    state = _context8.t0;

                    state = defineVariable(state, ident.name, state.value);
                    return _context8.abrupt("return", state.with({ value: undefined }));

                case 6:
                case "end":
                    return _context8.stop();
            }
        }
    }, _marked[7], this);
}
function evalFunctionDeclaration(node, state) {
    var ident, closure;
    return regeneratorRuntime.wrap(function evalFunctionDeclaration$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    ident = node.id;
                    closure = new Closure_1.default(node, state.frames.first());

                    state = defineVariable(state, ident.name, closure);
                    return _context9.abrupt("return", state.with({ value: undefined }));

                case 4:
                case "end":
                    return _context9.stop();
            }
        }
    }, _marked[8], this);
}
function evalIfStatement(node, state) {
    return regeneratorRuntime.wrap(function evalIfStatement$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    return _context10.delegateYield(evalExpression(node.test, state), "t0", 1);

                case 1:
                    state = _context10.t0;

                    if (!state.value) {
                        _context10.next = 7;
                        break;
                    }

                    return _context10.delegateYield(evalBlockStatement(node.consequent, state), "t2", 4);

                case 4:
                    _context10.t1 = _context10.t2;
                    _context10.next = 9;
                    break;

                case 7:
                    return _context10.delegateYield(evalBlockStatement(node.alternate, state), "t3", 8);

                case 8:
                    _context10.t1 = _context10.t3;

                case 9:
                    state = _context10.t1;
                    return _context10.abrupt("return", state);

                case 11:
                case "end":
                    return _context10.stop();
            }
        }
    }, _marked[9], this);
}
function evalExpressionStatement(node, state) {
    return regeneratorRuntime.wrap(function evalExpressionStatement$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    return _context11.delegateYield(evalExpression(node.expression, state), "t0", 1);

                case 1:
                    state = _context11.t0;
                    return _context11.abrupt("return", state);

                case 3:
                case "end":
                    return _context11.stop();
            }
        }
    }, _marked[10], this);
}
function evalReturnStatement(node, state) {
    return regeneratorRuntime.wrap(function evalReturnStatement$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    return _context12.delegateYield(evalExpression(node.argument, state), "t0", 1);

                case 1:
                    state = _context12.t0;
                    return _context12.abrupt("return", state.with({ _isReturned: true }));

                case 3:
                case "end":
                    return _context12.stop();
            }
        }
    }, _marked[11], this);
}
function evalBlockStatement(node, state) {
    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, stmt;

    return regeneratorRuntime.wrap(function evalBlockStatement$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _iteratorNormalCompletion2 = true;
                    _didIteratorError2 = false;
                    _iteratorError2 = undefined;
                    _context13.prev = 3;
                    _iterator2 = node.body[Symbol.iterator]();

                case 5:
                    if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                        _context13.next = 14;
                        break;
                    }

                    stmt = _step2.value;
                    return _context13.delegateYield(evalStatement(stmt, state), "t0", 8);

                case 8:
                    state = _context13.t0;

                    if (!state._isReturned) {
                        _context13.next = 11;
                        break;
                    }

                    return _context13.abrupt("break", 14);

                case 11:
                    _iteratorNormalCompletion2 = true;
                    _context13.next = 5;
                    break;

                case 14:
                    _context13.next = 20;
                    break;

                case 16:
                    _context13.prev = 16;
                    _context13.t1 = _context13["catch"](3);
                    _didIteratorError2 = true;
                    _iteratorError2 = _context13.t1;

                case 20:
                    _context13.prev = 20;
                    _context13.prev = 21;

                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }

                case 23:
                    _context13.prev = 23;

                    if (!_didIteratorError2) {
                        _context13.next = 26;
                        break;
                    }

                    throw _iteratorError2;

                case 26:
                    return _context13.finish(23);

                case 27:
                    return _context13.finish(20);

                case 28:
                    return _context13.abrupt("return", state.with({ _isReturned: false }));

                case 29:
                case "end":
                    return _context13.stop();
            }
        }
    }, _marked[12], this, [[3, 16, 20, 28], [21,, 23, 27]]);
}
function evalProgram(node, state) {
    return regeneratorRuntime.wrap(function evalProgram$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    return _context14.delegateYield(evalBlockStatement(node, start(state)), "t0", 1);

                case 1:
                    state = _context14.t0;
                    return _context14.abrupt("return", stop(state));

                case 3:
                case "end":
                    return _context14.stop();
            }
        }
    }, _marked[13], this);
}
exports.evalProgram = evalProgram;
//# sourceMappingURL=evaluator.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/evaluator.js
// module id = 178
// module chunks = 3